/**
 * Route path constants
 * Grouped by feature for better organization and maintainability
 */

// Base routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  NOT_FOUND: '*',
} as const;

// Auth routes
export const AUTH_ROUTES = {
  CALLBACK: '/auth/callback',
  ERROR: '/auth/error',
  CLIO_REDIRECT: '/clio-redirect',
  QBO_REDIRECT: '/qbo-redirect',
} as const;

// Reports routes
export const REPORTS_ROUTES = {
  BASE: '/reports',
  AR: {
    BASE: '/reports/ar',
    DASHBOARD: '/reports/ar/dashboard',
    HISTORY: '/reports/ar/history',
  },
  TRUST: {
    BASE: '/reports/trust',
    DASHBOARD: '/reports/trust/dashboard',
    HISTORY: '/reports/trust/history',
  },
  MATTER_LEDGER: {
    BASE: '/reports/matter-ledger',
    DASHBOARD: '/reports/matter-ledger/dashboard',
    HISTORY: '/reports/matter-ledger/history',
  },
  MATTER_STATEMENT: {
    BASE: '/reports/matter-statement',
    DASHBOARD: '/reports/matter-statement/dashboard',
    HISTORY: '/reports/matter-statement/history',
  },
  JUNIPER_EMAIL: {
    BASE: '/reports/juniper-email',
  },
} as const;

// Settings routes
export const SETTINGS_ROUTES = {
  BASE: '/settings',
  REPORTING_CONFIG: '/settings/reporting-config',
  ARCHIVAL: '/settings/archival',
  JUNIPER_CONFIG: '/settings/juniper-config',
  TEMPLATE_MANAGER: '/settings/template-manager',
  CLIO_INTEGRATION: '/settings/clio-integration',
  WEBHOOKS: '/settings/webhooks',
  WEBHOOK_ACTIVITY: '/settings/webhook-activity',
  QBO_WEBHOOKS: '/settings/qbo-webhooks',
  QBO_WEBHOOK_ACTIVITY: '/settings/qbo-webhook-activity',
  DATA_REPLICATION_CONFIGURATION: '/settings/data-replication/configuration',
  DATA_REPLICATION_MATTERS: '/settings/data-replication/matters',
  DATA_REPLICATION_CONTACTS: '/settings/data-replication/contacts',
  DATA_REPLICATION_BILLS: '/settings/data-replication/bills',
  DATA_REPLICATION_BANK_ACCOUNTS: '/settings/data-replication/bank-accounts',
  DATA_REPLICATION_BANK_TRANSACTIONS: '/settings/data-replication/bank-transactions',
  DATA_REPLICATION_ACTIVITIES: '/settings/data-replication/activities',
  DATA_REPLICATION_ACTIVITY_DESCRIPTIONS: '/settings/data-replication/activity-descriptions',
  DATA_REPLICATION_EXPENSE_CATEGORIES: '/settings/data-replication/expense-categories',
  DATA_REPLICATION_TASKS: '/settings/data-replication/tasks',
  DATA_REPLICATION_USERS: '/settings/data-replication/users',
  DATA_REPLICATION_LINE_ITEMS: '/settings/data-replication/line-items',
  DATA_REPLICATION_ALLOCATIONS: '/settings/data-replication/allocations',
  DATA_REPLICATION_UTBMS_CODES: '/settings/data-replication/utbms-codes',
  DATA_REPLICATION_UTBMS_SETS: '/settings/data-replication/utbms-sets',
} as const;

// Juniper routes
export const JUNIPER_ROUTES = {
  TRANSACTIONS: '/juniper-transactions',
  PDF_VIEWER: '/juniper/pdf-viewer/:juniperId',
  DOCUMENT_VIEWER: '/juniper/document-viewer/:juniperId',
} as const;

// Support routes
export const SUPPORT_ROUTES = {
  FEEDBACK: '/support/feedback',
} as const;

// Public routes
export const PUBLIC_ROUTES = {
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
} as const;

// Helper function to create viewer route with id
export const createViewerRoute = (type: 'pdf' | 'document', juniperId: string): string => {
  return type === 'pdf'
    ? `/juniper/pdf-viewer/${juniperId}`
    : `/juniper/document-viewer/${juniperId}`;
};
